import { FILE_SOURCE_MAP } from './constants';
import { WorkerInstance } from './worker-utils/worker-instance';

interface IUploadContentAndMetadataFileArgs {
  contentFile: File;
  metadataJSON: Record<any, any>;
}

export const uploadContentAndMetadataFile = async (
  contentPayload: IUploadContentAndMetadataFileArgs
) => {
  const { contentFile, metadataJSON } = contentPayload;

  const [contentIpfsHash, metadataIpfsHash] = await Promise.all([
    WorkerInstance.uploadToIPFS(contentFile, contentFile.name, []),
    WorkerInstance.uploadToIPFS(metadataJSON, contentFile.name, [
      FILE_SOURCE_MAP.DDOC,
    ]),
  ]);

  return {
    contentIpfsHash,
    metadataIpfsHash,
  };
};
